import { showNotification } from 'utils/appUtils';
import { trackUserAnalytics } from '../lib/analytics/useAnalyticsTrack';
import { ERROR_EVENTS } from '../lib/amplitude/events';

export const showErrorNotification = (message, opts) => {
  trackUserAnalytics({
    eventType: ERROR_EVENTS.VIEW_ERROR_NOTIFICATION,
    eventProperties: {
      page: window.location.pathname,
    },
    avoidBackendTracking: true,
  });

  showNotification('error', message || 'Oops, something went wrong. Please try again.', opts);
};

export const showGraphQLErrors = (apolloError) => {
  const { graphQLErrors, networkError } = apolloError;

  if (networkError) {
    showErrorNotification(networkError.message || 'A network-related error occurred.');
  }

  for (const e of graphQLErrors) {
    showErrorNotification(e.message);
  }
};
